import { useEffect, useState } from 'react';

import { useSite } from '../context/site';
import { NAME } from '../shared';

function GenderCellTemplate({ child }) {
    const { lists } = useSite();

    const [genders, setGenders] = useState([]);
    const [gendersLoaded, setGendersLoaded] = useState(false);

    useEffect(() => {
        if (!gendersLoaded) {
            const _genders = lists.filter((l) => l.listType === NAME.listType.gender);

            setGenders(_genders);
            setGendersLoaded(true);
        }
    }, [lists, gendersLoaded]);

    if (!gendersLoaded) {
        return null;
    }

    const genderId = child.gender?._id ? child.gender._id : child.gender;
    const gender = genders.find((g) => g._id === genderId);

    return gender?.itemName ? gender.itemName : 'No Gender';
}

export default GenderCellTemplate;
